module.exports = __webpack_public_path__ + "static/apuntes_bessel-19464cc7427047e8c1e3b59e796fe383.pdf";